enum ListenerEvent {
  AddFavorite = 'add_favorite',
  CloseModal = 'close_modal',
  Error = 'error',
  FavoriteAdded = 'favorite_added',
  FavoriteRemoved = 'favorite_removed',
  OnLoad = 'on_load',
  RefreshFinancing = 'refresh_financing',
  RemoveFavorite = 'remove_favorite',
  SaveSearch = 'save_search',
  SebsReadiness = 'sebs_readiness',
  TradeInToggled = 'trade_in_toggled',
  UpdateGeolocation = 'update_geolocation'
}

export default ListenerEvent;
